import React from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  ListGroup,
  ListGroupItem
} from 'reactstrap';

import { Wrapper } from './styles/backendTechStyles';
import { list } from './backendTechsData';

const BackendTechs = props => {
  return (
    <Wrapper className='bg-primary'>
      <Container className='h-100'>
        <Row className='h-100 align-items-start'>
          {list.map((item, index) => (
            <Col lg={3} md={3} sm={12} key={index} className='mb-3'>
              <Card>
                <CardBody>
                  <span className='h1 text-center d-block'>
                    <i className={`${item.iconClassname}`}></i>
                  </span>
                  <p className='lead text-center text-uppercase text-muted'>
                    {item.title}
                  </p>
                  {item.techs.map((tech, index) => (
                    <ListGroup key={index}>
                      <ListGroupItem className='mb-3'>{tech}</ListGroupItem>
                    </ListGroup>
                  ))}
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </Wrapper>
  );
};

export default BackendTechs;
